Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _react = require("react");
var _reactNative = require("react-native-web");
var _Header = require("../Header");
var _styles = require("../../styles");
var _utils = require("../../utils");
var useStyles = exports.useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_Header.HeaderContext),
    textColor = _useContext.textColor;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold;
  var _useWindowDimensions = (0, _utils.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var value = Object.assign({}, fontBold, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.xxl,
    lineHeight: _styles.STYLES.lineHeight.xxl
  });
  if (bp.tablet) {
    value.fontSize = (0, _styles.getREM)(2.5);
    value.lineHeight = (0, _styles.getREM)(2.5 * 1.5);
  }
  if (bp.desktop) {
    value.fontSize = (0, _styles.getREM)(3);
    value.lineHeight = (0, _styles.getREM)(3 * 1.5);
  }
  var label = Object.assign({}, fontBold, {
    color: textColor || colors.brand,
    fontSize: _styles.STYLES.fontSize.l,
    lineHeight: _styles.STYLES.lineHeight.l,
    textAlign: 'center'
  });
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet, bp.desktop])) {
    label.fontSize = _styles.STYLES.fontSize.xl;
    label.lineHeight = _styles.STYLES.lineHeight.xl;
    label.marginTop = _reactNative.Platform.OS === 'web' ? "-".concat(spacing.normal) : -spacing.normal;
  }
  var imageContainer = {
    height: Math.min(222, width * 0.5006875)
  };
  if (bp.desktop) {
    imageContainer.height = Math.min(250, width * 0.5006875);
  }
  var styles = _reactNative.StyleSheet.create({
    container: {
      maxWidth: _styles.STYLES.grid.maxBoxWidth,
      width: '100%',
      alignSelf: 'center',
      flex: 0
    },
    imageContainer: imageContainer,
    image: {},
    valueContainer: Object.assign({}, _reactNative.StyleSheet.absoluteFillObject, {
      top: '17%',
      justifyContent: 'center',
      alignItems: 'center'
    }),
    value: value,
    label: label
  });
  return {
    styles: styles
  };
};